import { Settings } from '@streamr/tv-engine';
const MOBILE_WIDTH = 960;
const MOBILE_HEIGHT = 540;
let cachedMobile;
export function isMobileDevice() {
    if (cachedMobile !== undefined)
        return cachedMobile;
    cachedMobile =
        typeof navigator !== 'undefined' &&
            /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    return cachedMobile;
}
let cached;
export function getCanvasResolution() {
    if (cached)
        return cached;
    cached = isMobileDevice()
        ? { width: MOBILE_WIDTH, height: MOBILE_HEIGHT }
        : {
            width: Settings.videoEncoderDefaultWidth,
            height: Settings.videoEncoderDefaultHeight,
        };
    return cached;
}
